import React, {useState} from 'react';
import LabelField from '../label-field/LabelField.component';
import ValidField from '../valid-field/ValidField.component';

export default function ValidLabelField(props) {
  const [isFocus, setIsFocus] = useState(false);
  return (
    <ValidField
      {...props}
      isFocus={isFocus}
      children={
        <LabelField {...props} isFocus={isFocus} setIsFocus={setIsFocus} />
      }
    />
  );
}
